<template>
  <v-container fluid>
    <v-form :readonly="true">
      <v-row dense>

        <v-col cols="12" v-if="membres?.length">
          <v-card class="rounded-lg">
            <v-card-title class="am-t2 bold">
              <v-row dense class="space-between align-center">
                <div>Membres de la direction</div>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="4" v-for="m in membres" :key="m.key">
                  <a-personne-visualisation-card :value="m"/>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" v-if="membresFondateurs?.length">
          <v-card class="rounded-lg">
             <v-card-title class="am-t2 bold">
              <v-row dense class="space-between align-center">
                <div>Membres fondateurs</div>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="4" v-for="m in membresFondateurs" :key="m.key">
                  <a-fondateur-visualisation-card :value="m"/>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" v-if="liquidateurs?.length">
          <v-card class="rounded-lg">
            <v-card-title class="am-t2 bold"> Liquidateurs </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="4" v-for="m in liquidateurs" :key="m.key">
                  <a-personne-visualisation-card :value="m" mode="liquidateur"/>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import makeSaisieComponent from "@/mixins/forms/makeSaisieComponent";

export default {
  mixins: [makeSaisieComponent()]
};
</script>
